const colors = {
    primary: "#0d47a1",
    light: "#5472d3",
    dark: "#002171",
}

export default colors;